import { UserRole } from '.';
import { Values } from '../utils/types';

export const PERMISSIONS_KEYS_BY_ACTION = {
  archive: 'can_archive',
  associate_beacon: 'can_associate_beacon',
  associate_device: 'can_associate_device',
  associate_parcel: 'can_associate_parcel',
  create_article: 'can_create_article',
  create_cluster_member: 'can_create_cluster_member',
  create_crop: 'can_create_crop',
  create_equipment: 'can_create_equipment',
  create_observation_category: 'can_create_observation_category',
  create_observation: 'can_create_observation',
  create_parcel: 'can_create_parcel',
  create_phyto_mixture: 'can_create_phyto_mixture',
  create_phyto_product: 'can_create_phyto_product',
  create_tag: 'can_create_tag',
  create_task_type: 'can_create_task_type',
  create_task: 'can_create_task',
  create_user: 'can_create_user',
  delete: 'can_delete',
  export: 'can_export',
  read_report: 'can_read_report',
  rent: 'can_rent',
  send_email: 'can_send_email',
  share: 'can_share',
  show_worked_area: 'can_show_worked_area',
  unlink: 'can_unlink',
  update: 'can_update',
  update_mixture_content: 'can_update_mixture_content',
} as const;

export type Permission = Values<typeof PERMISSIONS_KEYS_BY_ACTION>;

export type Permissions = Partial<Record<Permission, boolean | UserRole[]>>;
